import { ticker } from '@/api/server/common/ticker';
import { NavigateFunction } from 'react-router-dom';
import { toast } from 'react-toastify';

type TickerType = {
  navigate?: NavigateFunction;
};
export const setTicker = async ({ navigate }: TickerType): Promise<string> => {
  const obj = {
    symbol: 'SFL',
    amount: '1',
  };
  const re = await ticker(obj);
  if (re?.statusCode !== 200) {
    toast.error('ticker error');
    navigate && navigate('/pools');
    return '0';
  }
  return re.data.latest_price;
};
